module.exports = __webpack_public_path__ + "resources/ring-f2985674c76e1fe81e48590f47d7f0b8.svg";